import { toast } from 'sonner';

import { useImportAccountsFromTradeOn } from './queries';

import { humanErrorMessage } from '@/api/errors';
import { FileUploadDialog } from '@/components/file-upload-dialog';
import { pluralRu } from '@/lib/plural-ru';

const MAX_BYTES = 50 * 1024 * 1024;
const ERROR_FORMS = { one: 'ошибка', few: 'ошибки', many: 'ошибок' };

export interface AccountImportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDone?: (imported: number, failed: number) => void;
}

export const AccountImportDialog = ({ open, onOpenChange, onDone }: AccountImportDialogProps) => {
  const importAccounts = useImportAccountsFromTradeOn();

  const handleSubmit = (file: File): void => {
    importAccounts.mutate(file, {
      onSuccess: (result) => {
        toast.success(
          `Импортировано: ${String(result.imported)} · ${pluralRu(result.failed.length, ERROR_FORMS)}`,
        );
        onDone?.(result.imported, result.failed.length);
        onOpenChange(false);
      },
      onError: (err) => toast.error(humanErrorMessage(err)),
    });
  };

  return (
    <FileUploadDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Импорт TradeOn 7z"
      description="Архив .7z с дампом аккаунтов TradeOn. Парсится на сервере; ошибки — в сводке."
      accept=".7z,application/x-7z-compressed"
      maxBytes={MAX_BYTES}
      onSubmit={handleSubmit}
      isPending={importAccounts.isPending}
      submitLabel="Импортировать"
    />
  );
};
